import {
  CLIENT_SIDE_STRIPE_ERROR,
  CLIENT_SIDE_STRIPE_PAYMENT_INTENT_LAST_PAYMENT_ERROR,
  CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR
} from '@app/common/src/components/PlanPurchaseExperience/constants'
import { ClientSideError, ClientSideErrorType, cloneErrorObject, logger } from '@dtx-company/logger'
import { PaymentIntentOrSetupIntentResult } from '@stripe/stripe-js'
import { getEnPaymentMessage } from '@app/common/src/components/PlanPurchaseExperience/usePaymentMethodError'

export const handlePaymentIntentSetupIntentErrors = async ({
  paymentError,
  paymentIntent,
  setupIntent
}: {
  paymentError: PaymentIntentOrSetupIntentResult['error']
  paymentIntent: PaymentIntentOrSetupIntentResult['paymentIntent']
  setupIntent: PaymentIntentOrSetupIntentResult['setupIntent']
}): Promise<void> => {
  try {
    if (paymentError) {
      const error = new ClientSideError({
        message: paymentError.message || 'Action cancelled, try again',
        code: paymentError.decline_code || paymentError.code || CLIENT_SIDE_STRIPE_ERROR,
        type: ClientSideErrorType.ClientSideError,
        name: CLIENT_SIDE_STRIPE_ERROR
      })
      throw error
    } else if (paymentIntent?.last_payment_error || setupIntent?.last_setup_error) {
      const error = new ClientSideError({
        message:
          paymentIntent?.last_payment_error?.message ||
          setupIntent?.last_setup_error?.message ||
          'Last payment error',
        code:
          paymentIntent?.last_payment_error?.decline_code ||
          setupIntent?.last_setup_error?.decline_code ||
          paymentIntent?.last_payment_error?.code ||
          setupIntent?.last_setup_error?.code ||
          CLIENT_SIDE_STRIPE_PAYMENT_INTENT_LAST_PAYMENT_ERROR,
        type: ClientSideErrorType.ClientSideError,
        name: CLIENT_SIDE_STRIPE_PAYMENT_INTENT_LAST_PAYMENT_ERROR
      })
      throw error
    } else if (
      paymentIntent &&
      paymentIntent?.status != 'processing' &&
      paymentIntent?.status != 'succeeded'
    ) {
      const error = new ClientSideError({
        message: paymentIntent?.status || 'Payment intent status is not processing or succeeded',
        code: CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR,
        type: ClientSideErrorType.ClientSideError,
        name: CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR
      })
      throw error
    } else if (
      setupIntent &&
      setupIntent?.status != 'processing' &&
      setupIntent?.status != 'succeeded'
    ) {
      const error = new ClientSideError({
        message: paymentIntent?.status || 'Setup intent status is not processing or succeeded',
        code: CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR,
        type: ClientSideErrorType.ClientSideError,
        name: CLIENT_SIDE_STRIPE_PAYMENT_INTENT_STATUS_ERROR
      })
      throw error
    }
  } catch (e) {
    const displayedMessage = await getEnPaymentMessage(e)
    const error = new ClientSideError({
      ...cloneErrorObject(e),
      code: e.code || e.message,
      type: e.type || ClientSideErrorType.ClientSideValidationError,
      message: displayedMessage
    })
    logger.logError(error, { team: 'monetization' })
    throw error
  }
}
